export default __webpack_public_path__ + "static/media/calender.26b6ce68.svg";